import { RemoteVitalsPage } from "./remoteVitals";

export const RemoteVitals = RemoteVitalsPage;
